import { steps } from '@/modules/onboarding/source/steps'

import type { Answer } from '@/__generated__/requests'

export const getOnboardingDefaultValues = () => {
  let newValues: Answer[] = []

  steps.forEach(step => {
    newValues = [
      ...newValues,
      ...step.fields.map(field => ({
        answer: '',
        fieldName: field.field_name,
        isBirthDate: field.isBirthDate,
        isFinancial: field.isFinancial,
        isGenderField: field.isGenderField,
        isHidden: field.isHidden,
        isIncomeField: field.isIncomeField,
        isRaceField: field.isRaceField,
        question: field.question,
      })),
    ]
  })

  return newValues
}
